import { get } from 'lodash';

export const ORTPAD_1 = 'ORTPAD-1';

export default (code = '', translations = {}) => get(translations, [code || 'DEFAULT']);
